export default {
  'imddb-header.dropdown.items': [
    { label: 'Graphics', href: '#/' },
    { label: 'Overview', href: '#/' },
    { label: 'Visual overview', href: '#/' },
    { label: 'Backgrounder', href: '#/' },
    { label: 'About this project', href: '#/', active: true }
  ],
  'project.name': 'Secret Papers',
  'app.name': 'Awesome App',
  'app.home': './',
  'app.donate-url': 'https://www.icij.org/donate/',
  'contact-email': 'contact@icij.org',
  'content-placeholder.rows': [
    {
      height: '1em',
      boxes: [
        [0, '50%'],
        ['5%', '30%'],
        ['5%', '10%']
      ]
    }
  ],
  'donate-form.tracker': null,
  'sharing-options.url': null,
  'sharing-options.title': 'Awesome App by ICIJ',
  'sharing-options.description': 'null',
  'sharing-options.media': null,
  'signup-form.tracker': 'EXTERNAL',
  'signup-form.action':
    'https://icij.us15.list-manage.com/subscribe/post?u=0d48a33b1c24d257734cc2a79&id=992ecfdbb2',
  'signup-form.email-field': 'EMAIL',
  'signup-form.default-groups': ['group[9][1]'],
  'textured-deck.background-base-url': 'https://icij.github.io/murmur',
  'map.topojson.world-countries-sans-antarctica':
    'https://icij.github.io/murmur/assets/topojson/world-countries-sans-antarctica.json',
  'map.topojson.france-departements':
    'https://icij.github.io/murmur/assets/topojson/france-departements.json'
}
